export default (state, groups) => {
  state.groups = groups;
}
